import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { isEmpty } from 'bold-ui'

import { ConsultaSeguimentoPergunta17Model } from './model-consultaSeguimentoPergunta17'
import {
  hasPergunta17TentaFazerQueOlheAnySim,
  isPergunta17TentaFazerQueOlheAllNao,
} from './utils-consultaSeguimentoPergunta17'

export const PERGUNTA_17_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta17Model> = {
  PERGUNTA_17_HEADER: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: 'PERGUNTA_17_TENTA_FAZER_QUE_OLHE',
      },
    ],
  },
  PERGUNTA_17_TENTA_FAZER_QUE_OLHE: {
    scrollConditions: [
      {
        if: (_, allValues) => hasPergunta17TentaFazerQueOlheAnySim(allValues),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (_, allValues) => isPergunta17TentaFazerQueOlheAllNao(allValues),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_17_HEADER',
  },
}
